export class UserFormPermissions {
  canUserEdit: boolean;
  canUserEditProjectInfo: boolean;
  canUserSign: boolean;
  canUserViewSignature: boolean;
  canUserView: boolean;
  canDelete: boolean;
  canInternal: boolean;
}
